export const CANDIDATE_PROFILE_TABLE_ID = 'candidate-profile-list';

/**
 * Search params left out of the candidate table's scroll restoration key.
 * `sessionId` is the selection session: it's added to the URL when a candidate
 * is first selected or invited from their profile, and carried back to the
 * table, but doesn't change which rows are shown (PAD-4224).
 */
export const CANDIDATE_PROFILE_TABLE_SCROLL_IGNORED_PARAMS = ['sessionId'];

/**
 * Names the workflow a recruiter came from in the builder, so the Add to workflow picker
 * opens on it. The builder's hand-off link must use this key.
 */
export const WORKFLOW_ID_PARAM = 'workflowId';

/**
 * Names the conversation the candidate page opens on, in Other campaigns. The builder's
 * outreach URL helper must use this key.
 */
export const CONVERSATION_ID_PARAM = 'conversationId';

/**
 * The most candidates the configured add-to-job action will accept in one go, as the
 * customer set it. Past this the action is withheld rather than sending a silently
 * truncated selection.
 */
export const ADD_TO_JOB_ACTION_CANDIDATE_LIMIT = 100;

/**
 * The most teams one talent list can be shared with; the server refuses more.
 */
export const MAX_LIST_TEAMS = 50;
